<img class='logo-customer' src='assets/images/nebalik_logo.png' alt='logo'/>
<img class='logo-courier' src='assets/images/nebalik_logo_kuryr.svg' alt='logo'/>
